var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConversao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 43H28M13 9H37M13 40H37M35 4H15C13.9 4 13 4.9 13 6V44C13 45.1 13.9 46 15 46H35C36.1 46 37 45.1 37 44V6C37 4.9 36.1 4 35 4Z",
    stroke: "#4B5055",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 21C29 21 29 17 25 17C21 17 21 21 21 21C21 26.667 30 23.542 30 29C30 29 30 33 25 33C20 33 20 28 20 28M25 14V17M25 36V33",
    stroke: "#4B5055",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversao);
export default __webpack_public_path__ + "static/media/conversao.6af6df8d2a919a678587cee33d332034.svg";
export { ForwardRef as ReactComponent };